import * as React from 'react';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { isPartnerCompanyRoleId } from '../utilities/roleUtility';
import { enableTouch } from '../utilities/tabletUtil';
import { setFieldIdToURL, getCompanyId } from '../utilities/commonUtil';
import {
  hasChoseiPermission,
  hasNyutaiPermission,
  hasRoanPermission,
  noPermissionDialog,
} from '../utilities/companyUserPermissionUtil';
import dialogLoader from '../utilities/dialogLoader';
import RoanUtility from '../utilities/roanUtility';

const logoNames = {
  CONFERENCE: 'conference',
  GATEKEEPER: 'gatekeeper',
  ROAN: 'roan',
  PROGRESS: 'progress',
  TRACKER: 'tracker',
};

/**
 * @description サービス選択ドロップダウン
 */
export class DropdownServiceLogo extends React.Component {
  constructor(props) {
    super(props);
    const path = window.location.pathname.split('/');
    this.state = {
      closed: true,
      use_gk_flg: sessionStorage.getItem('use_gk_flg'), // 入退場管理利用
      use_roan_flg: sessionStorage.getItem('use_roan_flg'), // 労務安全利用
      use_progress_flg: sessionStorage.getItem('use_progress_flg'), // 進捗歩掛利用
      use_tracker_flg: sessionStorage.getItem('use_tracker_flg'), // 車両管理利用
      pathname: path[1], // url
    };

    this.handleToggleServiceLogo = this.handleToggleServiceLogo.bind(this); // サービス選択ドロップダウン開閉(iPad用)
    this.logos = this.logos.bind(this);
    this.conferenceLogo = this.conferenceLogo.bind(this);
    this.gateKeeperLogo = this.gateKeeperLogo.bind(this);
    this.roanLogo = this.roanLogo.bind(this);
    this.progressLogo = this.progressLogo.bind(this);
    this.roleId = LocalStorageService.getRoleId();
    this.joiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();

    this.companyId = getCompanyId();

    document.addEventListener('mousedown', this.handleClick, false);
    this.fieldId = SessionStorageService.getFieldId();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }

    this.handleClickOutside();
  };

  handleClickOutside = () => {
    this.setState({ closed: true });
  };

  /**
   * @description サービス選択ドロップダウン開閉(iPad用)
   */
  handleToggleServiceLogo = () => {
    this.setState({ closed: !this.state.closed });
  };

  /**
   * サービス利用権限がない旨のダイアログを表示する
   * */
  showNoPermissionDialog = () => {
    dialogLoader.show(noPermissionDialog, {
      callback: {
        done: () => {
          dialogLoader.close();
        },
      },
    });
  };

  /**
   * 調整会議に遷移する
   * */
  goToChosei = async () => {
    const permission = await hasChoseiPermission(this.companyId);
    if (permission) {
      window.location.replace('/conference/0/0/0/Dashboard:1/Dashboard:0');
    } else {
      this.showNoPermissionDialog();
    }
  };

  /**
   * 入退場に遷移する
   * */
  goToNyutai = async () => {
    const permission = await hasNyutaiPermission(this.companyId);
    if (permission) {
      window.location.replace('/gatekeeper/0/0/0/InOutDashboard:1/0:0');
    } else {
      this.showNoPermissionDialog();
    }
  };

  /**
   * 労務安全に遷移する
   * */
  gotoRoan = async () => {
    const permission = await hasRoanPermission(this.companyId);
    if (permission) {
      RoanUtility.setSessionSelectedPartnerCompanyIdBeforeMoveRoan();
      SessionStorageService.removeLastCheckedTimeOfExpiration();
      window.location.replace(setFieldIdToURL(new URL(process.env.REACT_APP_GREENFILE_URL)));
    } else {
      this.showNoPermissionDialog();
    }
  };

  /**
   * 進捗歩掛に遷移する
   * */
  gotoProgress = () => {
    window.location.replace('/progress/0/0/0/ProgressSchedule:1/0:0');
  };

  gotoTracker = async () => {
    const permission = await hasChoseiPermission(this.companyId);
    if (permission) {
      window.location.replace(
        `/tracker/transportationGroup?__currentFieldId=${this.fieldId}&__currentCompanyId=${this.companyId}`
      );
    } else {
      this.showNoPermissionDialog();
    }
  };

  logos = () => {
    const DropdownStyle = (closed, style) => {
      if (
        !this.state.use_gk_flg &&
        !this.state.use_roan_flg &&
        !this.state.use_progress_flg &&
        !this.state.use_tracker_flg
      ) {
        return style;
      }
      if (!closed) {
        style += ' show';
      }
      return style;
    };
    const logoName = pathname => {
      switch (pathname) {
        case logoNames.CONFERENCE:
          return 'logo-title--tyousei';
        case logoNames.GATEKEEPER:
          return 'logo-title--nyutai';
        case logoNames.ROAN:
          return 'logo-title--rouan';
        case logoNames.PROGRESS:
          return 'logo-title--progress';
        case logoNames.TRACKER:
          return 'logo-title--tracker';
        default:
          return 'logo-title--tyousei';
      }
    };
    return (
      <div
        id='logo-list'
        className='dropdown-single-select'
        style={{ width: '100%' }}
        onClick={this.handleToggleServiceLogo}
        ref={node => (this.node = node)}
      >
        <div className='dropdown-single-select__header logo-dropdown__hover current'>
          <div
            id='logo-list-button'
            className={DropdownStyle(this.state.closed, 'logo-header')}
          >
            <div className={logoName(this.state.pathname)} />
          </div>
          <i className='i-arrow-bottom--light i-3x' />
        </div>
        <div
          id='logo-list-dropdown'
          className={DropdownStyle(
            this.state.closed,
            'logo-dropdown logo-dropdown--dropdown-single-select'
          )}
        >
          <div className='logo-dropdown__item'>
            {this.conferenceLogo()}
            {this.progressLogo(this.state.use_progress_flg)}
            {this.gateKeeperLogo(this.state.use_gk_flg)}
            {this.roanLogo(this.state.use_roan_flg)}
            {this.trackerLogo(this.state.use_tracker_flg)}
          </div>
        </div>
      </div>
    );
  };
  /**
   * 調整会議
   */
  conferenceLogo = () => {
    if (this.state.pathname === 'conference') {
      return <div />;
    } else {
      return (
        <div className='logo-dropdown__hover'>
          <div className='logo-dropdown__item--border'>
            <div
              className='logo-dropdown__item--logo'
              onClick={() => {
                if (!enableTouch()) {
                  this.goToChosei();
                }
              }}
              onTouchEnd={e => {
                e.preventDefault();
                this.goToChosei();
              }}
            >
              <div className='logo-title--tyousei' />
            </div>
          </div>
        </div>
      );
    }
  };

  /**
   * 入退場管理
   * @param use_gk_flg {int}
   */
  gateKeeperLogo = use_gk_flg => {
    if (this.canShow(use_gk_flg, 'gatekeeper')) {
      return (
        <div className='logo-dropdown__hover'>
          <div className='logo-dropdown__item--border'>
            <div
              className='logo-dropdown__item--logo'
              onClick={() => {
                if (!enableTouch()) {
                  this.goToNyutai();
                }
              }}
              onTouchEnd={e => {
                e.preventDefault();
                this.goToNyutai();
              }}
            >
              <div className='logo-title--nyutai' />
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };
  /**
   * 労務安全
   * @param use_roan_flg {int}
   */
  roanLogo = use_roan_flg => {
    if (this.canShow(use_roan_flg, 'roan')) {
      // 環境変数param確認用(安定して動けばlog削除)
      // console.log(
      //   'debug',
      //   'DropdownServiceLogo.jsx',
      //   process.env.REACT_APP_GREENFILE_URL
      // );
      return (
        <div className='logo-dropdown__hover'>
          <div className='logo-dropdown__item--border'>
            <div
              className='logo-dropdown__item--logo'
              onClick={() => {
                if (!enableTouch()) {
                  this.gotoRoan();
                }
              }}
              onTouchEnd={e => {
                e.preventDefault();
                this.gotoRoan();
              }}
            >
              <div className='logo-title--rouan' />
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  /**
   * 進捗歩掛
   * @param use_progress_flg {int}
   */
  progressLogo = use_progress_flg => {
    if (this.canShow(use_progress_flg, 'progress')) {
      return (
        <div className='logo-dropdown__hover'>
          <div className='logo-dropdown__item--border'>
            <div
              className='logo-dropdown__item--logo'
              onClick={() => {
                if (!enableTouch()) {
                  this.gotoProgress();
                }
              }}
              onTouchEnd={e => {
                e.preventDefault();
                this.gotoProgress();
              }}
            >
              <div className='logo-title--progress' />
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  trackerLogo = use_tracker_flg => {
    if (this.canShow(use_tracker_flg, 'tracker')) {
      return (
        <div className='logo-dropdown__hover'>
          <div className='logo-dropdown__item--border'>
            <div
              className='logo-dropdown__item--logo'
              onClick={() => {
                if (!enableTouch()) {
                  this.gotoTracker();
                }
              }}
              onTouchEnd={e => {
                e.preventDefault();
                this.gotoTracker();
              }}
            >
              <div className='logo-title--tracker' />
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  canShow = (flgItem, checkPathName) => {
    if (Number(flgItem) === 1 && this.state.pathname !== checkPathName) {
      if (
        checkPathName === logoNames.GATEKEEPER ||
        checkPathName === logoNames.ROAN ||
        checkPathName === logoNames.PROGRESS ||
        checkPathName === logoNames.TRACKER
      ) {
        // 入退場と労務安全の場合
        if (isPartnerCompanyRoleId(this.roleId) && !this.joiningFlag) {
          // 元請固有の協力会社ユーザの場合は表示しない
          return false;
        }
      }
      return true;
    }

    return false;
  };

  render() {
    return <div className='global-header__logo'>{this.logos()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/DropdownServiceLogo.jsx